import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed: the reference screenshots came from
  // `digitopia.co/impact-labs/ebooks/generations-of-excellence-5-steps-to-transform-and-sustain-your-family-business/`
  // on 2026-08-28 and carry that address in their filenames, so the real slug
  // is the whole title and `generations-of-excellence` (the part before the
  // colon) was a wrong guess.
  'generations-of-excellence-5-steps-to-transform-and-sustain-your-family-business',
  'Generations of Excellence: 5 Steps to Transform and Sustain Your Family Business',
  `${UPLOADS}/2024/07/Generations-of-Excellence-1080X1080-400x400.jpg`,
  {
    confirmed: true,
    download: pdf('0ca92deb-b73d-405f-b435-b86b676332de-Generations of Excellence.pdf'),
    // Designed as its own written page on 2026-08-28, the eighth — so the card
    // goes there and `prerender.tsx` skips it, rather than generating this
    // template over the top of it.
    href: '/en/impact-labs/ebooks/generations-of-excellence-5-steps-to-transform-and-sustain-your-family-business',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 13
